<template>
    <div v-if="isActive" class="js-order-modal c-order-modal">
        <div class="c-order-modal__inner">
            <div class="c-order-modal__content">

                <div @click="isActive = false" class="c-order-modal__close js-order-modal__close"></div>

                <div class="c-order-modal__header">
                    <div class="c-order-modal__header-section">
                        <div class="c-order-modal__header-section-title">
                            Order details
                        </div>
                        <div class="c-order-modal__header-section-value">
                            {{ orderData.formatted_date }}
                        </div>
                    </div>
                    <div class="c-order-modal__header-section">
                        <div class="c-order-modal__header-section-title">
                            Order number
                        </div>
                        <div class="c-order-modal__header-section-value">
                           {{ orderData.id }}
                        </div>
                    </div>
                    <div class="c-order-modal__header-section">
                        <div class="c-order-modal__header-section-title">
                           Status
                        </div>
                        <div class="c-order-modal__header-section-value">
                           {{ orderData.status }}
                        </div>
                    </div>
                </div>

                <div class="c-order-modal__summary">
                    <div class="c-order-modal__summary-section">
                        <div class="c-order-modal__summary-section-title">
                            Delivery address
                        </div>
                        <div v-html="orderData.delivery_address_html" class="c-order-modal__summary-section-value"></div>
                    </div>
                    <div class="c-order-modal__summary-section">
                        <div class="c-order-modal__summary-section-title">
                            Payment method
                        </div>
                        <div class="c-order-modal__summary-section-value">
                            {{ orderData.payment_method }}
                        </div>
                    </div>
                    <div class="c-order-modal__summary-section">
                        <div class="c-order-modal__summary-section-title">
                            Order summary
                        </div>
                        <div class="c-order-modal__summary-section-value">
                            <div class="c-order-modal__order-summary">
                                <div class="c-order-modal__order-summary-row">
                                    <div class="c-order-modal__order-summary-row-key">
                                        Item(s) Subtotal (excl VAT)
                                    </div>
                                    <div v-html="orderData.subtotal_amount" class="c-order-modal__order-summary-row-value"></div>
                                </div>
                                <div class="c-order-modal__order-summary-row">
                                    <div class="c-order-modal__order-summary-row-key">
                                        VAT
                                    </div>
                                    <div v-html="orderData.tax_amount" class="c-order-modal__order-summary-row-value"></div>
                                </div>
                                <div class="c-order-modal__order-summary-row">
                                    <div class="c-order-modal__order-summary-row-key">
                                        Post & Packing
                                    </div>
                                    <div v-html="orderData.shipping_amount" class="c-order-modal__order-summary-row-value"></div>
                                </div>
                                <div class="c-order-modal__order-summary-row">
                                    <div class="c-order-modal__order-summary-row-key">
                                        Discount
                                    </div>
                                    <div v-html="orderData.discount_amount" class="c-order-modal__order-summary-row-value"></div>
                                </div>
                                <div class="c-order-modal__order-summary-row is-total">
                                    <div class="c-order-modal__order-summary-row-key">
                                        TOTAL
                                    </div>
                                    <div v-html="orderData.total" class="c-order-modal__order-summary-row-value"></div>
                                </div>
                            </div>
                        </div>
                        <!-- <InvoiceModal :poCode="`IO${orderData.id.substring(5)}`" :accountNumber="orderData.customer_account_number" /> -->
                    </div>
                </div>

                <div class="c-order-modal__order-items">
   
                    <div v-for="item in orderData.items" class="c-order-modal__order-item">
                        <div class="c-order-modal__order-item-section">
                            <div class="c-order-modal__order-item-section-title">
                                Item ordered
                            </div>  
                            <div class="c-order-modal__order-item-section-value">
                                {{ item.name }}
                                <img class="c-order-modal__order-item-thumbnail" :src="item.thumbnail"/>
                            </div>
                        </div>
                        <div class="c-order-modal__order-item-section">
                            <div class="c-order-modal__order-item-section-title">
                                SKU
                            </div>  
                            <div class="c-order-modal__order-item-section-value">
                               {{ item.sku }}
                            </div>
                        </div>
                        <div class="c-order-modal__order-item-section">
                            <div class="c-order-modal__order-item-section-title">
                                Qty
                            </div>  
                            <div class="c-order-modal__order-item-section-value">
                               {{ item.qty }}
                            </div>
                        </div>
                        <div class="c-order-modal__order-item-section">
                            <div class="c-order-modal__order-item-section-title">
                                Price (ex VAT)
                            </div>  
                            <div v-html="item.price" class="c-order-modal__order-item-section-value"></div>
                            <div class="c-order-modal__order-item-actions">
                                <a href="/contact-us">Cancellation</a>
                                <a href="/returns">Return</a>
                                <a :href="item.url + '#review-form'">Leave a review</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import InvoiceModal from './InvoiceModal.vue';

    export default {
        name: 'OrderModal',
        props: {
            orderNumber: {
                type: String,
                required: true
            },
            clickTrigger: {
                type: HTMLElement,
                required: true
            }
        },
        components: {
            InvoiceModal
        },
        data() {
            return {
                isActive: false,
                fetchingOrderData: false,
                error: null,
                orderData: null
            }
        },
        methods: {
            async fetchOrderData() {
                this.fetchingOrderData = true;

                if(this.orderData) {
                    this.fetchingOrderData = false;
                    this.isActive = true;
                    return;
                }

                try {
                    const response = await fetch(
                        `/rest/V1/swallowdental/online-orders?type=order_number&search=${this.orderNumber}`,
                    );

                    if (!response || !response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }

                    const data = await response.json();
                    this.error = null;
                    this.fetchingOrderData = false;
                    this.isActive = true;
                    this.orderData = data[0];

                } catch (error) {
                    this.fetchingOrderData = false;
                    this.orderData = null;
                    // this.error = error.message;
                    console.error("Error fetching order data:", error);
                }
            }
        },
        mounted() {
            this.clickTrigger.addEventListener('click', async (e) => {
                e.preventDefault();
                await this.fetchOrderData();
            })
        }
    }
</script>